/**
 * Enviar's brand mark: a "send" arrow taking off toward the top-right
 * over concentric signal waves (wave/arrow/broadcast motif). It is drawn
 * in `currentColor` to inherit the context's color (accent chip, hero…)
 * and be theme-aware without hardcoding. Purely decorative (`aria-hidden`).
 */

import type { Component, JSX } from "solid-js";

interface SendMarkProps {
  class?: string;
  style?: JSX.CSSProperties | string;
}

export const SendMark: Component<SendMarkProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.1"
    stroke-linecap="round"
    stroke-linejoin="round"
    class={props.class}
    style={props.style}
    aria-hidden="true"
  >
    {/* Ondas de señal (broadcast) irradiando desde abajo-izquierda */}
    <path d="M3.5 20.5a5 5 0 0 1 5-5" opacity="0.9" />
    <path d="M3.5 20.5a9.5 9.5 0 0 1 9.5-9.5" opacity="0.5" />
    {/* Flecha de envío despegando hacia arriba-derecha */}
    <path d="M20.5 3.5 9.5 14.5" />
    <path d="M13.5 3.5h7v7" />
  </svg>
);
